import React, { useState, useEffect, useContext } from 'react';
import { Routes, Route } from "react-router-dom";
import { Stack, Button, Typography, Box, useMediaQuery } from '@mui/material';
import Orders from './Orders';
import Refs from './Refs';
import Requisites from './Requisites';
import Settings from './Settings';
import { useNavigate, useLocation } from 'react-router-dom';
import { getText } from '../../libs/utils';
import { useTheme, styled } from "@mui/material/styles";
import { SliderArrowR } from '../../assets/images/icons';
import { UserDataContext } from '../../App';
import { VerifiedUser } from '@mui/icons-material';
import { ContentBox } from '../../libs/theme';

const TabGrid = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '0 0 36px',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'start'
  },
  [theme.breakpoints.only('sm')]: {
    margin: '8px 0 32px'
  },
  "h3": {
    [theme.breakpoints.down('md')]: {
      margin: '0 0 26px'
    },
    [theme.breakpoints.only('xs')]: {
      margin: '-5px 0 32px'
    },
  }
}))

const MySlider = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  ".leftArrow": {
    width: '30px',
    textAlign: 'left',
    "svg": {
      transform: 'scale(-1, 1)',
    },
  },
  ".rightArrow": {
    width: '30px',
    textAlign: 'right'
  },
  ".disabled": {
    opacity: 0.4,
    pointerEvents: 'none'
  },
  ".MuiButton-root": {
    width: 'calc(100% - 60px)'
  }
}))

const Account = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const userData = useContext(UserDataContext);
  const { pathname } = useLocation();
  let isXS = useMediaQuery(theme.breakpoints.only('xs'));

  const tabs = [
    { title: getText('accTabOrdersLabel'), path: '/account' },
    { title: getText('refInfoHed'), path: '/account/refs' },
    { title: getText('accTabRequisite'), path: '/account/requisites' },
    { title: getText('accTabSetLabel'), path: '/account/settings' }
  ]

  const [currentTab, setCurrentTab] = useState(tabs.findIndex(item => item.path === pathname));

  const handleTabChange = (type) => {
    if (type === 'prev') {
      navigate(tabs[currentTab - 1].path)
      setCurrentTab(currentTab - 1)
    }
    else {
      navigate(tabs[currentTab + 1].path)
      setCurrentTab(currentTab + 1)
    }
  }

  useEffect(() => {
    setCurrentTab(tabs.findIndex(item => item.path === pathname));
  }, [pathname])

  const hasKyc = userData.hasKyc;

  return (
    <>
      <ContentBox sx={{
        padding: { xs: '12px 23px', sm: '15px 32px' }, borderRadius: '24px',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        display: 'flex',
        gap: '16px',
        marginBottom: '32px'
      }}>

        <Typography variant="h6"              >
          {hasKyc ? getText('profVerified') : getText('profNotVerified')}
        </Typography>
        {hasKyc && <VerifiedUser sx={{ color: '#2eb680' }} />}
        {!hasKyc && <Button variant="contained" size="small"
          sx={{
            borderRadius: '16px',
            padding: '4px 16px',
          }}

          href="/kyc-pass" component="a">{getText("goToKyc")}</Button>}
      </ContentBox>
      <TabGrid>
        <Typography variant='h3' sx={{ marginBottom: 0 }}>{getText('lkHeader')}</Typography>
        {isXS
          ? <MySlider>
            <Box
              className={`leftArrow ${currentTab == 0 && 'disabled'}`}
              onClick={() => handleTabChange('prev')}
            >
              <SliderArrowR />
            </Box>

            <Button
              color="secondary"
              variant='contained'
            >
              {tabs[currentTab].title}
            </Button>

            <Box
              className={`rightArrow ${(tabs.length - 1) == currentTab && 'disabled'}`}
              onClick={() => handleTabChange('next')}
            >
              <SliderArrowR />
            </Box>
          </MySlider>
          : <Stack direction="row" spacing={1} justifyContent="flex-end">
            {tabs.map((item, tabKey) => (
              <Button
                key={tabKey}
                color="secondary"
                variant={pathname === item.path ? "contained" : ""}
                onClick={() => navigate(item.path)}
                sx={{ lineHeight: '16px' }}
              >
                {tabs[tabKey].title}
              </Button>
            ))}
          </Stack>
        }
      </TabGrid>

      <Routes>
        <Route index element={<Orders />} />
        <Route path="/refs" element={<Refs />} />
        <Route path="/requisites" element={<Requisites />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </>
  )
}

export default Account